import { DeviceAttributeRow as SharedDeviceAttributeRow } from '@/features/dryad';
import { ConditionType } from './condition-types';
import { ConditionTypeSelect } from './condition-type-select';
import { PEOPLE_SEARCH_OPERATOR_FAMILIES } from './attribute-plugin';
import { PEOPLE_ATTRIBUTE_FIELD_POLICY } from './attribute-filter';

type DeviceAttributeRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared device-attribute row. */
export function DeviceAttributeRow({ id }: DeviceAttributeRowProps) {
  return (
    <SharedDeviceAttributeRow
      id={id}
      conditionType={ConditionType.DeviceAttribute}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.DeviceAttribute} />}
      operatorFamilies={PEOPLE_SEARCH_OPERATOR_FAMILIES}
      fieldPolicy={PEOPLE_ATTRIBUTE_FIELD_POLICY}
    />
  );
}
